<svelte:options accessors />

<script context="module">
  export const PICKER_TOOLBAR_EVENTS = {
    cancel: 'cancel',
    confirm: 'confirm',
  };
</script>

<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  export let title = '';
  export let cancelButtonText = '取消';
  export let confirmButtonText = '确定';

  const dispatch = createEventDispatcher();

  const onCancel = () => {
    dispatch(PICKER_TOOLBAR_EVENTS.cancel);
  };

  const onConfirm = () => {
    dispatch(PICKER_TOOLBAR_EVENTS.confirm);
  };
</script>

<div class="iwan-picker-toolbar">
  <button class="iwan-picker-toolbar-cancel" on:click={onCancel}>{cancelButtonText}</button>
  <div class="iwan-picker-toolbar-title">{title}</div>
  <button class="iwan-picker-toolbar-confirm" on:click={onConfirm}>{confirmButtonText}</button>
</div>

<style lang="scss">
  .iwan-picker-toolbar {
    position: relative;
    background-color: #ffffff;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;

    .iwan-picker-toolbar-cancel {
      color: #969799;
    }

    .iwan-picker-toolbar-cancel,
    .iwan-picker-toolbar-confirm {
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
    }

    .iwan-picker-toolbar-title {
      max-width: 50%;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
</style>
